
enum CompanyHotelPriceRecommendationEngineVersion {
	NORMAL = 'NORMAL',
	LITE = 'LITE'
}

export default CompanyHotelPriceRecommendationEngineVersion